import styled from "styled-components";

export const ErrorText = styled.span`
  color: red;
  position: relative;
  top: 1rem;
`;
